import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;

export const getBaseData = (() => {
  return async (id: string, params: any): Promise<{ data: any }> => {
    return api
      .get(`${apiEndPoint}/${id}`, {
        params,
      })
      .then((response) => {
        return {
          data: response.data.data || response.data.grades || response.data,
        };
      });
  };
})();
